/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {isInstrumentLinkDenylisted} from '../api'

export const useMutationIsInstrumentLinkDenylisted = createReactQueryMutationHook('isInstrumentLinkDenylisted', isInstrumentLinkDenylisted)
